export default "__VITE_ASSET__aa67692d__"